function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from 'react';
import KitchenSinkComponentMapperContext from './KitchenSinkComponentMapperContext';
var withMapping = function withMapping(BaseComponent) {
  return function (props) {
    var componentIsWrapped = props.componentIsWrapped;
    var context = useContext(KitchenSinkComponentMapperContext);
    if (context && BaseComponent && !componentIsWrapped && context[BaseComponent.name]) {
      var WrapperComponent = context[BaseComponent.name];
      return /*#__PURE__*/React.createElement(WrapperComponent, _extends({}, props, {
        componentIsWrapped: true
      }), props.children);
    }
    return /*#__PURE__*/React.createElement(BaseComponent, props, props.children);
  };
};
export default withMapping;